export default function Recommendation() {
  const recommendations = [
    {
      icon: 'ri-line-chart-line',
      text: '株式や不動産など、価格変動の激しい投資に疲れを感じている方'
    },
    {
      icon: 'ri-search-eye-line',
      text: '表面的な利回りではなく、ビジネスの「成立理由」を納得して選びたい方'
    },
    {
      icon: 'ri-heart-3-line',
      text: '銀行に眠らせている資金を、社会貢献（マイクロファイナンス）に役立てたい方'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      text: '管理の手間を一切かけず、毎月安定した「副収入」を得たい方'
    }
  ];

  return (
    <section className="py-20 md:py-32 bg-[#F9F9F9]">
      <div className="max-w-7xl mx-auto px-8 md:px-16">
        {/* Heading */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-[#1A2B4A] leading-tight font-serif">
            こんな方におすすめ
          </h2>
        </div>

        {/* Recommendation Cards */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {recommendations.map((item, index) => (
            <div 
              key={index}
              className="group bg-white border-2 border-[#D4AF37] rounded-3xl p-10 hover:shadow-2xl hover:shadow-[#D4AF37]/20 transition-all duration-300 hover:-translate-y-2 cursor-pointer"
            >
              {/* Icon */}
              <div className="w-20 h-20 flex items-center justify-center bg-[#1A2B4A] rounded-full mx-auto mb-6 group-hover:bg-[#D4AF37] transition-colors duration-300">
                <i className={`${item.icon} text-white text-4xl`}></i>
              </div>

              {/* Text */}
              <p className="text-base md:text-lg text-gray-700 text-center leading-relaxed font-serif">
                {item.text}
              </p>
            </div>
          ))}
        </div>

        {/* Additional Message */}
        <div className="mt-16 text-center">
          <div className="inline-block bg-white p-8 rounded-2xl shadow-lg border-2 border-[#1A2B4A] max-w-3xl">
            <i className="ri-user-star-line text-[#D4AF37] text-5xl mb-4"></i>
            <p className="text-xl font-bold text-[#1A2B4A] mb-3 font-serif">
              投資経験の有無は問いません
            </p>
            <p className="text-base text-gray-600 leading-relaxed font-serif">
              初めての方でも理解できるよう、基礎から丁寧に説明いたします。<br />
              「なぜ成立しているのか」という本質を、納得いくまでお伝えします。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
